import { render, staticRenderFns } from "./ExportPageNumerationTab.vue?vue&type=template&id=667c76c6&scoped=true"
import script from "./ExportPageNumerationTab.vue?vue&type=script&lang=js"
export * from "./ExportPageNumerationTab.vue?vue&type=script&lang=js"
import style0 from "./ExportPageNumerationTab.vue?vue&type=style&index=0&id=667c76c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c76c6",
  null
  
)

export default component.exports